import { CommonModule, NgClass } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { WalletService } from 'src/app/pages/wallet/wallet.service';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CsCurrencyConverterComponent } from 'src/app/shared/components/cs-currency-converter/cs-currency-converter.component';
import { CsCurrencyUnitDisplayComponent } from 'src/app/shared/components/cs-currency-unit-display/cs-currency-unit-display.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { BetDetailsData } from 'src/app/shared/interfaces/gameorder.interface';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { MatConnectedDialogRef } from 'src/app/shared/service/connected-dialog';
import { MiniGameService } from '../../minigame/minigame.service';

@Component({
  selector: 'app-bet-details',
  standalone: true,
  imports: [
    NgClass,
    CSIconButtonComponent,
    CSButtonComponent,
    PipesModule,
    CsCurrencyConverterComponent,
    CsCurrencyUnitDisplayComponent,
    CommonModule,
  ],
  templateUrl: './bet-details.component.html',
  styleUrl: './bet-details.component.scss',
})
export class BetDetailsComponent {
  constructor(
    private dialogRef: MatConnectedDialogRef<BetDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BetDetailsData,
    private router: Router,
    private appService: AppService,
    private walletService: WalletService,
    private miniGameService: MiniGameService,
  ) {}

  /**後備遊戲圖片資源路徑 */
  protected readonly gameLogoErrImgSrc = this.miniGameService.defaultImg;

  get isSportBet() {
    return this.data.isSportBet;
  }

  get errorImg() {
    const sportDefaultImg = 'assets/images/game/default_sport.jpg';
    return this.isSportBet ? sportDefaultImg : this.gameLogoErrImgSrc;
  }

  /**点击游戏 */
  protected clickGameItem(item: BetDetailsData): void {
    const { isSportBet, webRedirectUrl, providerCatId, gameId } = item;
    const lang = this.appService.languageCode;
    if (webRedirectUrl) {
      this.router.navigateByUrl(`${lang}/${webRedirectUrl}`);
    } else if (isSportBet) {
      this.router.navigateByUrl(`${lang}/play/${providerCatId}/All`);
    } else {
      this.router.navigateByUrl(`${lang}/casino/games/${providerCatId}/${gameId}`);
    }
    this.closeBetDetails();
  }

  /**dialog關閉 */
  protected closeBetDetails(): void {
    this.dialogRef?.close();
  }

  /**BetId複製 */
  protected copyBetId(id: string): void {
    this.walletService.copy(id, 'Copy successful');
  }
}
